import {
  QuizStepQuestionIq,
  QuizStepQuestionType,
} from '@web-solutions/base-app/screens/quiz/interfaces';

import { IMAGES } from './images';

export const QUESTIONS: QuizStepQuestionIq[] = [
  {
    questionImage: IMAGES.CARD1,
    answersImages: [
      IMAGES.ANSWER1_1,
      IMAGES.ANSWER1_2,
      IMAGES.ANSWER1_3,
      IMAGES.ANSWER1_4,
      IMAGES.ANSWER1_5,
      IMAGES.ANSWER1_6,
    ],
    type: QuizStepQuestionType.SINGLE_IQ,
    correctAnswer: IMAGES.ANSWER1_3,
  },
];
